import styled from 'styled-components';

export const NewFeaturesStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .newFeatures {
    &__info {
      min-height: 205px;
      padding: 0 40px;
    }
    &__title {
      text-align: center;
      color: ${props => props.theme.uiColors.textSubtitleDefault};
      font-size: 18px;
      font-family: OpenSansRegular, serif;
      margin-top: 32px;
      margin-bottom: 5px;
    }
    &__description {
      color: ${props => props.theme.uiColors.selectorLabel};
      font-size: ${props => props.theme.fontSizeS};
      margin: 0;
    }
    &__image {
      img {
        height: 288px;
        max-width: fit-content;
        width: auto;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
      }
    }
    &__carrousel {
      display: flex;
      flex-direction: row;
      gap: 4px;
      margin: 53px 0px 53px 0px;
      &Item {
        width: 96px;
        height: 4px;
        background-color: ${props => props.theme.uiColors.contrastScaleModerate};
        border-radius: 4px;
        &--active {
          background-color: #80819C;
        }
      }
    }
    &__buttonSection {
      display: flex;
      padding: 0 40px 32px 40px;
      justify-content: flex-end;
      gap: var(--spacing-16);
      width: 100%;
    }
  }
`;
